import { render, staticRenderFns } from "./icon-server.vue?vue&type=template&id=0bfa157c&"
import script from "./icon-server.vue?vue&type=script&lang=js&"
export * from "./icon-server.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports